import { Pipe, PipeTransform } from '@angular/core';
import marked from 'marked';

@Pipe({
    name: 'markdown',
    standalone: false,
})
export class MarkdownPipe implements PipeTransform {
    constructor() {}

    transform(text: string): any {
        try {
            return marked(text);
        } catch (e) {
            return text;
        }
    }
}
